const indexWfFlow = () => import(/* webpackChunkName: "herb" */ './indexWfFlow');
const indexWfFsm = () => import(/* webpackChunkName: "herb" */ './indexWfFsm');

// const manager = () => import(/* webpackChunkName: "herb" */ './managerIndex');

//工作流流程引擎管理
export default {
  routes: [
    {
      path: '/wf/wfflow/index',
      name: 'index_wf_flow',
      component: indexWfFlow
    },
    {
      path: '/wf/wffsm/index',
      name: 'index_wf_fsm',
      component: indexWfFsm,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/wf/router.js